(function () {
  if (window.__eolReploAddToCartBound) {
    return;
  }
  window.__eolReploAddToCartBound = true;

  // Scoped to the exact 4 products in the "Browse Our Most-Loved Products"
  // homepage section, matched by the data-replo-product-handle attribute
  // Replo renders on each product card. This never touches the
  // Replo-generated markup itself (that file is auto-generated by the Replo
  // app and gets overwritten whenever that section is re-saved/published
  // from within Replo) -- it only relabels the existing "Shop now" links to
  // "Add to Cart" at runtime and wires them to the hidden add-to-cart form
  // Replo already renders for each product card.
  var TARGET_HANDLES = [
    'daily-cleanser',
    'soak-it-up',
    'puremoist-antioxidant-moisturizer',
    'glow-look-on-the-bright-side-10'
  ];
  var LABEL_TEXT = 'Add to Cart';

  function getCartUrls() {
    var urls = window.EOL_CART_URLS || {};
    return {
      add: urls.add || '/cart/add.js',
      cart: urls.cart || '/cart'
    };
  }

  function refreshCartContent() {
    var urls = getCartUrls();
    var ajaxCartUrl = urls.cart.replace(/\/+$/, '') + '?view=ajax';

    return fetch(ajaxCartUrl, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var contentTemplate = doc.querySelector('template[data-html="content"]');
        var newHtml = contentTemplate ? contentTemplate.innerHTML : '';

        if (newHtml) {
          document.querySelectorAll('.js-ajax-cart-content').forEach(function (el) {
            el.innerHTML = newHtml;
          });
        }

        var optionsTemplate = doc.querySelector('template[data-options]');
        if (optionsTemplate) {
          try {
            var opts = JSON.parse(optionsTemplate.textContent);
            if (typeof opts.item_count !== 'undefined') {
              document.querySelectorAll('.js-cart-count').forEach(function (el) {
                el.textContent = opts.item_count;
              });
            }
          } catch (e) {
            /* ignore parse errors */
          }
        }
      });
  }

  function labelNodeFor(link) {
    return link.querySelector('p, strong, span') || link;
  }

  function getTargetContainers() {
    var all = document.querySelectorAll('[data-replo-product-handle]');
    var matches = [];
    all.forEach(function (el) {
      var handle = el.getAttribute('data-replo-product-handle');
      if (handle && TARGET_HANDLES.indexOf(handle) !== -1) {
        matches.push(el);
      }
    });
    return matches;
  }

  // Cosmetic only -- relabels the visible "Shop now" text to "Add to Cart".
  // The click-to-cart behavior below does NOT depend on this having run, so
  // if Replo's client-side hydration is slow (or re-renders the card after
  // this has already applied) the worst case is the button still reads
  // "Shop now" while still correctly adding to cart when clicked.
  function relabelButtons() {
    getTargetContainers().forEach(function (container) {
      container.querySelectorAll('a').forEach(function (a) {
        var text = (a.textContent || '').trim().toLowerCase();
        if (text === 'shop now' || text === LABEL_TEXT.toLowerCase()) {
          var label = labelNodeFor(a);
          label.textContent = LABEL_TEXT;
          a.setAttribute('role', 'button');
        }
      });
    });
  }

  function findVariantId(anchor) {
    var container = anchor.closest('[data-replo-product-handle]');
    if (!container) {
      return null;
    }
    var handle = container.getAttribute('data-replo-product-handle');
    if (!handle || TARGET_HANDLES.indexOf(handle) === -1) {
      return null;
    }
    var input = container.querySelector('product-form form[data-type="add-to-cart-form"] input[name="id"]');
    return input && input.value ? input.value : null;
  }

  // Click handling is delegated on `document` and resolved fresh on every
  // click by walking up from the actual click target to the nearest
  // product container -- it does NOT rely on a class name that was added
  // ahead of time by relabelButtons(). Replo hydrates these cards
  // client-side and can re-render the anchor node after our relabel pass
  // has already run, which would silently strip any class we'd added and
  // let the link fall through to its normal href navigation. Matching
  // structurally (data-replo-product-handle + the hidden add-to-cart form)
  // instead of by class means it keeps working no matter when -- or how
  // many times -- Replo re-renders the card.
  //
  // IMPORTANT: this listener is registered on the CAPTURE phase (the final
  // `true` argument), not the default bubble phase. Replo's own client-side
  // hydration attaches its own click handler directly on this "Shop now"
  // link to drive its own navigation to the product page, and that handler
  // runs in the bubble phase at the target. Capture-phase listeners on an
  // ancestor (document) always run before bubble-phase listeners on the
  // target, no matter which script registered first -- so calling
  // stopPropagation() here reliably stops Replo's own handler from ever
  // running, instead of racing it.
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest ? e.target.closest('a') : null;
    if (!anchor) {
      return;
    }
    var variantId = findVariantId(anchor);
    if (!variantId) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    if (anchor.getAttribute('aria-disabled') === 'true') {
      return;
    }

    var urls = getCartUrls();
    var label = labelNodeFor(anchor);
    var originalText = label.textContent;
    anchor.setAttribute('aria-disabled', 'true');
    label.textContent = 'Adding…';

    fetch(urls.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && err.description) || 'Could not add that item to your cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        return refreshCartContent();
      })
      .then(function () {
        label.textContent = 'Added ✓';
        var trigger = document.querySelector('.js-mini-cart-trigger');
        if (trigger) {
          trigger.click();
        }
        setTimeout(function () {
          anchor.removeAttribute('aria-disabled');
          label.textContent = originalText;
        }, 1500);
      })
      .catch(function (err) {
        anchor.removeAttribute('aria-disabled');
        label.textContent = originalText;
        window.alert(err.message || 'Sorry, something went wrong adding that item.');
      });
  }, true);

  function injectReviewBadges() {
    getTargetContainers().forEach(function (container) {
      if (container.querySelector('.eol-replo-review-badge')) {
        return;
      }
      var handle = container.getAttribute('data-replo-product-handle');
      if (!handle) {
        return;
      }
      var tpl = document.getElementById('eol-stamped-badge-' + handle);
      if (!tpl) {
        return;
      }
      var badgeHtml = (tpl.innerHTML || '').trim();
      if (!badgeHtml) {
        return;
      }
      var anchor = container.querySelector('a');
      if (!anchor || !anchor.parentNode) {
        return;
      }
      var wrap = document.createElement('div');
      wrap.className = 'eol-replo-review-badge';
      wrap.style.margin = '6px 0 10px';
      wrap.innerHTML = badgeHtml;
      anchor.parentNode.insertBefore(wrap, anchor);
    });
  }

  function applyAll() {
    relabelButtons();
    injectReviewBadges();
  }

  function relabelWithRetries() {
    applyAll();
    // Replo hydrates this page client-side after initial load; re-apply a
    // few times in case that hydration pass happens after ours and resets
    // the button text or removes the injected badge.
    [300, 800, 1500, 3000, 6000].forEach(function (delay) {
      setTimeout(applyAll, delay);
    });

    // Belt-and-suspenders: keep watching for DOM changes inside the target
    // cards indefinitely (not just for the first few seconds), since Replo's
    // hydration timing isn't something we control or can fully predict.
    // This only touches cosmetic relabeling/badges -- it never re-attaches
    // click handling, since that's delegated on document and always
    // resolves fresh (see the click listener above).
    if (window.MutationObserver) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) {
          return;
        }
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          applyAll();
        }, 200);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relabelWithRetries);
  } else {
    relabelWithRetries();
  }
})();
